import { commonEnTranslations } from './common.en';
import { commonHeTranslations } from './common.he';

export const commonTranslations = {
  en: commonEnTranslations,
  he: commonHeTranslations,
} as const;
